import React from "react";
import { Routes, Route } from "react-router-dom";
import PrivateRoute from "./components/utils/PrivateRoute";
import Redirect from "./components/utils/Redirect";
import Login from "./components/Login";
import Crypto from "./pages/dashboardPage/Crypto";
import AuthApp2FaPage from "./components/AuthApp2Fa";
import AuthSelectPage from "./components/AuthSelect";
import TwoFaPage from "./components/TwoFA";
import ForgotPasswordPage from "./components/ForgotPassword";
import ResetPasswordPage from "./components/ResetPassword";
import SignupPage from "./components/Signup";
import VerifyMailPage from "./components/VerifyMail";
import KycOnboarding from "./components/KycOnboarding";
import Kyc from "./components/Kyc";
import Wallet from "./pages/Wallet/Wallet";
import Activities from "./pages/activity/Activities";
import Settings from "./pages/settings/Settings";
import KycVerificationGate from "./pages/settings/newKyc/KycVerificationGate";
import Trade from "./pages/trade/Trade";
import Survey from "./pages/survey/Survey";
import CacheBuster from "react-cache-buster";
import packageFiles from "../package.json";
import Loading from "./Loading";
import Auth from "./pages/auth/Auth";

import SmartCameraPage from "./components/mobile/SmartCameraForMobile";
import SmartDocumentPage from "./components/mobile/SmartDocumentForMobile";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <CacheBuster
      currentVersion={packageFiles.version}
      isEnabled={true} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
    >
      <Routes>
        <Route path="/auth" element={<Auth />} />
        {/* added by dammy: used in mobile app */}
        <Route path="/mobile/smile-id/selfie" element={<SmartCameraPage />} />
        <Route
          path="/mobile/smile-id/document"
          element={<SmartDocumentPage />}
        />

        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/verify-mail" element={<VerifyMailPage />} />
        <Route path="/2fa-auth-app" element={<AuthApp2FaPage />} />
        <Route path="/2fa-auth" element={<TwoFaPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/auth-select" element={<AuthSelectPage />} />
        <Route path="/" element={<Redirect to="/login" />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Crypto />
            </PrivateRoute>
          }
        />
        <Route
          path="/wallet"
          element={
            <PrivateRoute>
              <Wallet />
            </PrivateRoute>
          }
        />
        <Route
          path="/activity"
          element={
            <PrivateRoute>
              <Activities />
            </PrivateRoute>
          }
        />
        <Route
          path="/trade"
          element={
            <PrivateRoute>
              <Trade />
            </PrivateRoute>
          }
        />
        {/* Virtual cards — hidden for now
        <Route
          path="/cards"
          element={
            <PrivateRoute>
              <Cards />
            </PrivateRoute>
          }
        />
        */}
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <Settings />
            </PrivateRoute>
          }
        />
        {/* Reached only from a survey CTA or a deep link — deliberately absent from the
            sidebar, which is a hardcoded list in components/Dashboard.tsx. */}
        <Route
          path="/survey"
          element={
            <PrivateRoute>
              <Survey />
            </PrivateRoute>
          }
        />
        <Route
          path="/kyc-verification"
          element={<KycVerificationGate />}
        />
        <Route
          path="/kyc-onboarding"
          element={
            <PrivateRoute>
              <KycOnboarding />
            </PrivateRoute>
          }
        />
        <Route
          path="/kyc"
          element={
            <PrivateRoute>
              <Kyc />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </CacheBuster>
  );
}

export default App;
